import { environment } from "../../../../environments/environment";


export class apiConst{
    public static readonly userDetails = environment.apiBaseUri +'/sample';
    public static readonly activityHit = environment.analyticsBaseUri +'/analytics/applHits/save';
}
